// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.count {
  background: #f1f1f1;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: bold;
  border-radius: 2px;
}

:host-context(.mc-dark) .count {
  background: var(--mc-surface-2);
  border-color: var(--mc-surface-1);
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/reminder-badge/reminder-badge.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AACJ;;AAGI;EACI,+BAAA;EACA,iCAAA;AAAR","sourcesContent":[".count {\r\n    background: #f1f1f1;\r\n    padding: 2px 8px;\r\n    font-size: 11px;\r\n    font-weight: bold;\r\n    border-radius: 2px;\r\n}\r\n\r\n:host-context(.mc-dark) {\r\n    .count {\r\n        background: var(--mc-surface-2);\r\n        border-color: var(--mc-surface-1);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
